import React from 'react';
import { Tooltip } from "@mui/material";
import { Lock } from "lucide-react";
import { useSidebarPermissions } from '../hooks/useSidebarPermissions';

const Submenu = ({ items, location, onNavigation }) => {
  const { isSubmenuItemDisabled, getTooltipMessage } = useSidebarPermissions();
  
  if (!items || !Array.isArray(items)) {
    return null;
  }
  
  return (
    <div className="ml-4 -mt-1">
      <ul className="space-y-1">
        {items.map((subItem) => {
          if (!subItem || !subItem.name || !subItem.link) {
            return null;
          }
          
          const isActive = location?.pathname === subItem.link;
          const isDisabled = isSubmenuItemDisabled(subItem.name, subItem.link);
          
          const commonClasses = "flex items-center text-sm pl-2 py-1.5 rounded-lg transition-colors duration-200";
          const activeClasses = "bg-gray-300 text-black font-medium shadow-sm";
          const inactiveClasses = onNavigation ? "text-black hover:text-black hover:bg-gray-100" : "text-black hover:text-black hover:bg-gray-100";
          const disabledClasses = "text-gray-400 cursor-not-allowed";
          
          const handleClick = () => {
            if (!isDisabled && onNavigation && typeof onNavigation === 'function') {
              onNavigation(subItem);
            }
          };
          
          const buttonContent = onNavigation ? (
            <button
              onClick={handleClick}
              disabled={isDisabled}
              className={`${commonClasses} w-full text-left ${isActive ? activeClasses : isDisabled ? disabledClasses : inactiveClasses}`}
            >
              <div className="mr-2 flex-shrink-0">
                {subItem.icon && typeof subItem.icon === "string" ? (
                  <img
                    src={subItem.icon}
                    alt={subItem.name}
                    className={`w-3.5 h-3.5 filter brightness-0 ${isDisabled ? 'opacity-50' : ''}`}
                    onError={(e) => { e.target.onerror = null; e.target.style.display = "none"; }}
                  />
                ) : subItem.icon ? (
                  <subItem.icon className={`w-3.5 h-3.5 ${isDisabled ? 'opacity-50' : ''} ${isActive ? "text-black" : "text-black"}`} />
                ) : null}
              </div>
                <span className="font-medium">{subItem.name}</span>
                {isDisabled && (
                  <Lock className="w-3 h-3 text-gray-400 ml-2" />
                )}
            </button>
          ) : (
            <a
              href={isDisabled ? '#' : subItem.link}
              onClick={isDisabled ? (e) => e.preventDefault() : undefined}
              className={`${commonClasses} ${isActive ? "bg-gray-300 text-black font-medium" : isDisabled ? disabledClasses : inactiveClasses}`}
            >
              <div className="mr-2 flex-shrink-0">
                {typeof subItem.icon === "string" ? (
                  <img
                    src={subItem.icon}
                    alt={subItem.name}
                    className={`w-3.5 h-3.5 filter brightness-0 ${isDisabled ? 'opacity-50' : ''}`}
                    onError={(e) => { e.target.onerror = null; e.target.style.display = "none"; }}
                  />
                ) : (
                  <subItem.icon className={`w-3.5 h-3.5 ${isDisabled ? 'opacity-50' : ''} ${isActive ? "text-black" : "text-black"}`} />
                )}
              </div>
              <span className="font-medium">• {subItem.name}</span>
              {isDisabled && (
                <Lock className="w-3 h-3 text-gray-400 ml-2" />
              )}
            </a>
          );
          
          return (
            <li key={subItem.name}>
              {isDisabled && getTooltipMessage(subItem.name, '') ? (
                <Tooltip 
                  title={getTooltipMessage(subItem.name, '')} 
                  placement="right"
                  arrow
                >
                  <span>{buttonContent}</span>
                </Tooltip>
              ) : (
                buttonContent
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Submenu; 